import { useState, useEffect, forwardRef } from "react";
import MultiSelectDropDown from "../form-components/MultiSelectDropDownComponent";
import MultiSelectDropDownForm from "../form-components/MultiSelectDropDownFormComponent";

const FuelTypeAutocomplete = forwardRef((props, ref) => {
    const { allOption, selectedValues = [], disabled = false, prevId, nextId, isFormikFormField = false, showFormError = false, ...rest } = props;
    const fuelTypeOptions = [{ label: 'Diesel', stationId: 1 }, { label: 'DEF / Urea', stationId: 2 }, { label: 'CNG', stationId: 3 }];
    let initialProps = {
        ...rest,
        labelKey: 'label',
        primaryKey: 'stationId',
        options: fuelTypeOptions,
        isObject: true,
        isFormikFormField,
        showFormError,
        dataLoaded: false,
        disabled
    }
    const [defaultProps, setDefaultProps] = useState(initialProps);

    useEffect(() => {
        if (selectedValues.length > 0) {
            let preSelectedValues = [];
            if (selectedValues.length > 0) {
                preSelectedValues = fuelTypeOptions.filter((s) => selectedValues.indexOf(s.stationId) >= 0);
                const newProps = { ...defaultProps, preSelectedValues, dataLoaded: true }
                setDefaultProps(newProps);
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [selectedValues]);

    useEffect(() => {
        const newProps = { ...defaultProps, disabled, dataLoaded: true }
        setDefaultProps(newProps);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [disabled]);

    useEffect(() => {
        let preSelectedValues = [];
        if (selectedValues.length > 0) {
            preSelectedValues = defaultProps.options.filter((i) => selectedValues.indexOf(i.stationId) >= 0);
        }
        setDefaultProps({ ...defaultProps, nextId, prevId, preSelectedValues, dataLoaded: true });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [nextId, prevId]);

    return (defaultProps.dataLoaded ?
        !isFormikFormField ?
            <MultiSelectDropDown
                ref={ref}
                {...defaultProps}
            /> :
            <MultiSelectDropDownForm
                ref={ref}
                {...defaultProps}
            /> : <></>
    );
});

export default FuelTypeAutocomplete;